module.exports = __webpack_public_path__ + "img/paused_dark.ffb6be0c.svg";